// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__VHowi","title":"AfterImages90_title__2RRJo","images":"AfterImages90_images__1dBd-"};